export default __webpack_public_path__ + "static/media/green-right-arrow.f8226833.svg";